import type { ReactElement, ReactNode } from "react";

import styles from "./Card.module.css";

export interface CardProps {
  /** `section` with `labelledBy` becomes a named region; `article` is a self-contained item. */
  readonly as?: "div" | "section" | "article" | undefined;
  readonly labelledBy?: string | undefined;
  /** The mockup's `.card-pad`: 16px of padding for a card without a header row. */
  readonly padded?: boolean | undefined;
  readonly children: ReactNode;
}

/** The mockup's `.card`: a raised surface with a 1px border and the card radius, never a shadow. */
export function Card({ as: Element = "div", labelledBy, padded = false, children }: CardProps): ReactElement {
  const className = [styles.card, padded ? styles.padded : undefined].filter(Boolean).join(" ");
  return (
    <Element className={className} aria-labelledby={labelledBy}>
      {children}
    </Element>
  );
}

export interface CardHeaderProps {
  readonly children: ReactNode;
}

/** The mockup's `.card-head`: a 48px row above a hairline. */
export function CardHeader({ children }: CardHeaderProps): ReactElement {
  return <div className={styles.cardHeader}>{children}</div>;
}
